module.exports = __webpack_public_path__ + "img/google_play_badge.ae62e21b.png";